import { render, staticRenderFns } from "./AccountDeletionsView.vue?vue&type=template&id=5965f510&"
import script from "./AccountDeletionsView.vue?vue&type=script&lang=js&"
export * from "./AccountDeletionsView.vue?vue&type=script&lang=js&"
import style0 from "./AccountDeletionsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports